import { ClosingMethod } from 'services/campaign/types';
import { ConversationStatus } from 'generated-graphql/types';

export const progressScreeningStatusMapper = (closingMethod: ClosingMethod) => {
  switch (closingMethod) {
    case ClosingMethod.CUSTOM:
      return ConversationStatus.CompletedCustomRequest;
    case ClosingMethod.MEETING_URL:
      return ConversationStatus.CompletedMeetingRequested;
    case ClosingMethod.PHONE_NUMBER:
      return ConversationStatus.CompletedAwaitingCall;
    case ClosingMethod.CALENDAR_MEETING_INTEGRATION:
      return ConversationStatus.CompletedMeetingRequested;
  }
};
